import React from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"'`]/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol$1 = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
 * their corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * Backticks are escaped because in IE < 9, they can break out of
 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
 * [#133](https://html5sec.org/#133) of the
 * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape(string) {
  string = toString(string);
  return (string && reHasUnescapedHtml.test(string))
    ? string.replace(reUnescapedHtml, escapeHtmlChar)
    : string;
}

var lodash_escape = escape;

var oget = function (obj, path, def) {
    var res = path
    .replace(/\[/g, '.')
    .replace(/\]/g, '')
    .replace(/^\./, '')
    .split('.')
    .reduce(function (prev, curr) {
        return prev && prev[curr]
    }, obj);

    return (res === undefined)
      ? def
      : res;
};

function logger(type) {
  /* istanbul ignore next */
  if (process.env.NODE_ENV !== 'production' && (typeof window !== 'undefined' && window.console || typeof global !== 'undefined' && global.console)) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    // eslint-disable-next-line no-console
    (_console = console)[type].apply(_console, ['[pp-react-l10n]'].concat(args));
  }
}

var log = logger.bind(null, 'log');
log.warn = logger.bind(null, 'warn');
log.error = logger.bind(null, 'error');
log.info = logger.bind(null, 'info');

// this singleton allows content to be loaded asynchronously
// while still allowing content getters to be initialized
// and use the global content after content has loaded
var globalContent = {};

// this allows you to specify that no warnings should be displayed until
// the init function has been called
var status = {
  complete: false,
  logWarnings: true
};

function postponeWarnings() {
  status.logWarnings = false;
}

function setComplete() {
  status.complete = true;
  status.logWarnings = true;
}

/* istanbul ignore next */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator || '@@iterator';

var onContentMissingNoop = function () {};

function getContent() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var path = options.path,
      _options$content = options.content,
      content = _options$content === void 0 ? {} : _options$content,
      _options$onContentMis = options.onContentMissing,
      onContentMissing = _options$onContentMis === void 0 ? onContentMissingNoop : _options$onContentMis;

  if (!path) {
    return getCurriedGetContent(options);
  }

  var retrievedContent = oget(content, path);

  if (!retrievedContent) {
    onContentMissing(options);
    return getCurriedGetContent(options);
  } else if (Array.isArray(retrievedContent)) {
    return retrievedContent.map(function (c) {
      return getReactContent(c, options);
    });
  } else if (typeof retrievedContent !== 'string') {
    return getCurriedGetContent(options);
  }

  return getReactContent(retrievedContent, options);
}

function getCurriedGetContent(options) {
  // this function is the one folks will use most of the time.
  // it has a bit nicer API because most of the time people will
  // only be passing the `path` and `data` so those have been
  // put at param1 and param2, then the rest of the options are
  // in param3.
  function ppReactL10nGetContent(path, data) {
    var incomingOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return getContent(_objectSpread({}, options, incomingOptions, {
      // manually merge these things
      content: _objectSpread({}, globalContent, options.content, incomingOptions.content),
      path: [options.path, path].filter(Boolean).join('.'),
      data: _objectSpread({}, options.data, incomingOptions.data, data)
    }));
  }

  var pathAsString = options.path === '' ? '' : "{".concat(String(options.path), "}");
  // flow doesn't like assigning toString on the function...
  // $FlowIgnore
  Object.assign(ppReactL10nGetContent, _defineProperty({
    html: function (path, data) {
      var incomingOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return ppReactL10nGetContent(path, data, _objectSpread({
        useHTML: true
      }, incomingOptions));
    },
    // these methods ensure that things don't break
    // when there's a typo or the content doesn't load.
    toString: function () {
      return pathAsString;
    } // this is here as an error case.
    // if the developer attempts to render a content getter, react will
    // render with this iterator, so we can log an error and have it
    // render the pathAsString instead

  }, ITERATOR_SYMBOL, function () {
    var timesCalled = 0;
    var resultAtPath = oget(options.content, options.path);

    if (status.logWarnings) {
      log.error('An attempt was made to render a content getter function.', // eslint-disable-next-line no-nested-ternary
      !options.path ? 'This is because no path was provided' : resultAtPath ? "This is because the content at path \"".concat(String(options.path), "\" is not a string") : "This is because there is no content at the path \"".concat(String(options.path), "\""), {
        resultAtPath: resultAtPath,
        options: options
      });
    }

    return {
      next: function next() {
        return {
          done: timesCalled++ > 0,
          value: pathAsString
        };
      }
    };
  })); // prevent app from crashing when expecting content to be an array
  // but there is a typo or the content failed to load

  Object.getOwnPropertyNames(Array.prototype).forEach(function (method) {
    // flow doesn't like this for some reason...
    // $FlowIgnore
    if (Array.prototype[method].bind) {
      ppReactL10nGetContent[method] = Array.prototype[method].bind([pathAsString]);
    }
  });
  return ppReactL10nGetContent;
}
/**
 * Transforms a content string into a react compatible array
 * of with strings and react components.
 *
 * @param contentString i.e. 'I want to go see a {movie} at the theatre!'
 * @param options i.e. { data: { movie: <Movie/> } }
 * @return ['I want to go to see a ', <Movie/>, ' at the theatre!']
 */


function getReactContent(contentString, options) {
  if (status.logWarnings && typeof options.useHTML !== 'boolean' && process.env.NODE_ENV !== 'production' && Boolean(true) && // using require here to avoid it getting bundled
  // even though it should get tree-shaken anyway...
  // it didn't appear to get tree-shaken so... 🙃
  require('is-html')(contentString)) {
    log.warn("The content at the path \"".concat(String(options.path), "\" appears to have HTML."), 'If it is, set the option `useHTML` to `true`.', 'If it is not, then you can silence this warning by explicitly setting `useHTML` to `false`', {
      contentString: contentString,
      content: options.content
    });
  }

  var interpolatedContent = contentString.split(/({.*?})/).map(function (chunk, index) {
    if (index % 2 === 1) {
      var _ref = chunk.match(/^{(.*)}$/)
      /* istanbul ignore next: paranoid check */
      || [],
          _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[1];

      var val = oget(options.data, key);

      if (options.useHTML && React.isValidElement(val)) {
        throw new Error('[pp-react-l10n]: cannot pass react elements as data when useHTML is true.');
      }

      var escaped = options.useHTML ? lodash_escape(val) : val;
      return keyifyReactElements(escaped);
    }

    return chunk;
  });
  var shouldJoinContent = interpolatedContent.every(function (chunk) {
    return typeof chunk === 'string' || typeof chunk === 'number' || !chunk;
  });
  var joinedContent = shouldJoinContent ? interpolatedContent.join('') : interpolatedContent;

  if (options.useHTML && typeof joinedContent === 'string') {
    return innerHTML(joinedContent);
  }

  return joinedContent;
}
/**
 * This function is intended to take React components that are used in translations and add a `key` to them if needed
 * This is to prevent React from logging an error because in normal cases you would need a `key` for React to keep track
 * of the components in the array. We don't need this optimization for our l10n stuff, so we don't really need the
 * `key` in these components.
 *
 * This function dynamically adds a key to the component by making a clone of the component and adding a unique key to
 * it. This adds overhead. React doesn't log the warning when process.env.NODE_ENV === 'production'. So we likewise will
 * skip cloning the component in the same scenario. This should remove any issues regarding performance.
 *
 * @param {*} component the component to check (can be a String as well, which will be skipped)
 * @return {*} the cloned component/same thing you called this with depending on what was passed
 */


function keyifyReactElements(component) {
  if (process.env.NODE_ENV !== 'production' && component && typeof component !== 'string' && component.key === null) {
    return React.cloneElement(component, {
      key: Math.random()
    });
  }

  return component;
}

function innerHTML(__html) {
  return React.createElement('span', {
    key: __html,
    dangerouslySetInnerHTML: {
      __html: __html
    }
  });
}

var internalGetContent;

function getContentFacade() {
  if (!status.complete) {
    if (status.logWarnings) {
      throw new Error("[pp-react-l10n]: must be initialized before an attempt is made at getting content. If you're loading content asynchronously, you can disable this by calling the postponeWarnings function. In this case, make certain to rerender your application after you've initialized pp-react-l10n to avoid issues with components not displaying content.");
    }

    return getContent(_objectSpread({
      path: arguments.length <= 0 ? undefined : arguments[0],
      content: {},
      onContentMissing: logContentMissing
    }, arguments.length <= 1 ? undefined : arguments[1]));
  } // $FlowIgnore flow isn't smart enough to know that this is a GetContentFn


  return internalGetContent.apply(void 0, arguments);
}

function init() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // I'd prefer to destructure options in the parameter list, but flow had a hard time with that... No idea why
  var content = options.content,
      _options$contentNode = options.contentNode,
      contentNode = _options$contentNode === void 0 ? content ? null : document.getElementById('l10n-content') : _options$contentNode,
      _options$onContentMis = options.onContentMissing,
      onContentMissing = _options$onContentMis === void 0 ? logContentMissing : _options$onContentMis;

  if (content && contentNode) {
    log.error('INIT:error', 'You passed `content` and `contentNode`. You should only pass one. Using `content`.');
  }

  content = content ? content : getContentFromNode(contentNode); // $FlowIgnore flow isn't smart enough to know that by not passing path, it'll return a GetContentFn

  internalGetContent = getContent({
    content: content,
    onContentMissing: onContentMissing
  });
  setComplete();
  Object.assign(globalContent, content);
}

function getContentFromNode(node) {
  var content = {};

  if (!node || !node.innerHTML) {
    if (!node) {
      log.error('INIT:error', 'The `contentNode` does not exist.', "If you're using the default, make sure that the #l10n-content node is on the page", "If you're doing something custom, make sure the node you're passing exists before calling this.");
    } else {
      log.error('INIT:error The `contentNode` you provided has no content:', node);
    }
  } else {
    try {
      content = JSON.parse(node.innerHTML);
      log.info('INIT:parsed:content', content);
    } catch (e) {
      log.info('INIT:parsed:content:error', e); // ignore error. Maybe we should rethrow it?
    }
  }

  return content;
}

function logContentMissing(_ref) {
  var path = _ref.path,
      content = _ref.content;

  if (status.logWarnings) {
    log.warn("missing content for path \"".concat(String(path), "\" with the content:"), content);
  }
}

var version = String("2.1.0");

export default getContentFacade;
export { init, logContentMissing, getContent, version, postponeWarnings };
